module.exports = __webpack_public_path__ + "static/cover-fe8c4bb543afa3e18d49717edf4cb51a.jpg";